import { render, staticRenderFns } from "./PickUp.vue?vue&type=template&id=3a2bc960"
import script from "./PickUp.vue?vue&type=script&lang=js"
export * from "./PickUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports